// extracted by mini-css-extract-plugin
module.exports = {"buttons":"Z0-OE"};